import classes from "./index.module.scss";
import btnClasses from "../../../commons/Button.module.scss";
import RequestDemo from "../../../Button/RequestDemo";

export default function Approach() {
  return (
    <section className={classes.section}>
      <div className={classes.body}>
        <h2 className={classes.title}>
          Your business is unique and needs an individual approach
        </h2>
        <h3 className={classes.subtitle}>
          Contact us to reinvent the way you do it!
        </h3>
        <RequestDemo className={`${btnClasses.button} ${classes.button}`} />
      </div>
    </section>
  );
}
